import { IxLookupFilterDTO } from 'ix-ng-components';
import { Maybe } from 'ix-ng-static-utils';

export class RowsLookupDTO {
  id: Maybe<number> = null;
  numberOfRows: Maybe<string> = null;
  numberOfRowsAng: Maybe<string> = null;
  aktiven: Maybe<boolean> = null;
}

export class RowsLookupFilterDTO extends IxLookupFilterDTO<number> {
  prikaziAktivne: Maybe<boolean> = null;
}
